import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Import CloudScape design system styles
import '@cloudscape-design/global-styles/index.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);